import { FC } from 'react'

const CheckedIcon: FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    fill='none'
    viewBox='0 0 20 20'
  >
    <path
      fill='#88122B'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.869 5.215a.875.875 0 0 1 0 1.237l-8.334 8.334a.875.875 0 0 1-1.237 0l-4.167-4.167A.875.875 0 0 1 4.37 9.38l3.548 3.548 7.714-7.714a.875.875 0 0 1 1.238 0Z'
    />
  </svg>
)

export default CheckedIcon
